import React from 'react';
import memoize from 'memoize-one';

import { ApprovementStatus, BasicActionBtns } from '../../components';

export default memoize(clickHandler => [
  {
    name: 'NOMBRE DE GRUPO',
    selector: 'name',
    sortable: true,
    grow: '1'
  },
  {
    name: 'TRABAJADORES',
    selector: 'settlement_counter',
    sortable: true,
    center: true,
    grow: '1'
  },
  {
    name: 'FECHA DE CREACIÓN',
    selector: 'created_at',
    sortable: true,
    grow: '1'
  },
  {
    name: 'TOTAL LÍQUIDO',
    selector: 'liquid_amount',
    sortable: true,
    grow: '1'
  },
  {
    name: 'TOTAL BRUTO',
    selector: 'gross_amount',
    sortable: true,
    grow: '1'
  },
  {
    name: 'ESTADO',
    selector: 'status',
    cell: item => (
      <ApprovementStatus
        status={item.status}
        translatedStatus={item.translated_status}
        onClick={() => clickHandler(item, 'show')}
      />
    ),
    sortable: true,
    grow: '0.5'
  },
  {
    name: 'ACCIONES',
    cell: item => (
      <BasicActionBtns item={item} resource="SettlementGroup" clickHandler={clickHandler} disableDestroy disableEdit />
    ),
    ignoreRowClick: true,
    allowOverflow: false,
    right: true,
    grow: '0.5',
    minWidth: '123px'
  }
]);
